module.exports = __webpack_public_path__ + "img/rich-menu1.58daea0c.jpg";